import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=3a2137fa&"
import script from "./FieldItem.vue?vue&type=script&lang=js&"
export * from "./FieldItem.vue?vue&type=script&lang=js&"
import style0 from "./FieldItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports